export const TIME_FORMAT = {
    API: 'YYYY-MM-DD HH:MM:SS', // How the API formats time
    META: 'YYYY-MM-DDTHH:MM:SS.DD±HH:MM', // See HTML5 spec (proleptic-gregorian-calendar)
    PUBLISHED_TIME: 'DD.MM.YYYY'
};
